/*ReactJS*/
import React, { useState, useEffect, useContext } from 'react';
import { CSVLink } from 'react-csv';

/*Service*/
import {
  StatementDisclosure,
  ListStatementDisclosureRequest,
  ReadStatementDisclosureRequest,
} from '../../../proto/reportpb/statementdisclosure_grpc_web_pb';
import { TableSettings } from '../../../proto/admpb/tablesettings_grpc_web_pb';

/*Toast Notification*/
import {
  notifySuccess,
  notifyInfo,
  notifyError,
} from 'components/Notification/Notification';

/*Material UI Components*/
import {
  Typography,
  Button,
  Modal,
  Backdrop,
  Fade,
  Box,
  TextField,
  IconButton,
  Tooltip,
  Checkbox,
  FormControlLabel,
} from '@material-ui/core';

/*Material UI Table*/
import MUIDataTable from 'mui-datatables';

/*Icons*/
import {
  Add as AddIcon,
  Create as EditIcon,
  Save as SaveIcon,
  CheckCircle as CheckCircleIcon,
} from '@material-ui/icons';

/*Styles*/
import tableTheme from '../../../components/Table/TableStyle';
import { MuiThemeProvider } from '@material-ui/core/styles';
import useStyles from '../../../styles';

import { ServiceContext } from 'context/ServiceContext';
import { useUserState } from 'context/UserContext';

/*Moment JS*/
import moment from 'moment-timezone';

/*Custom components*/
import CorrespondentSelect from '../../../components/AutoComplete/Correspondent';
import SearchButton from '../../../components/Button/Search';

export default function StatementDisclosureTable({ params }) {
  var { googleAccount } = useUserState();

  const classes = useStyles();

  const {
    statementDisclosureServiceClient: statementdisclosure,
    tableSettingsServiceClient: tableSettings,
  } = useContext(ServiceContext);

  const search = () => {
    const pathWithParams =
      currentPath +
      '?search=true' +
      (correspondentValue ? '&correspondent=' + correspondentValue : '') +
      (statusValue ? '&status=' + statusValue : '');
    window.history.pushState({}, null, pathWithParams);

    setLoading(true);

    let list = new ListStatementDisclosureRequest();
    list.setCorrespondent(correspondentValue);
    list.setStatus(statusValue);

    statementdisclosure.listStatementDisclosure(list, {}, (err, res) => {
      if (err) {
        console.error(err);
        notifyError(err.message);
        setLoading(false);
        return;
      }
      const rows = res.toObject().disclosuresList;

      setRows(rows);
      notifyInfo(rows.length + ' search results.');
      setLoading(false);
    });
  };

  const save = () => {
    if (!modalCorrespondentValue) {
      notifyError('Correspondent is required.');
      return;
    }
    if (!modalDisclosureValue) {
      notifyError('Disclosure is required.');
      return;
    }

    if (modalAddAction) {
      let read = new ReadStatementDisclosureRequest();
      read.setCorrespondent(modalCorrespondentValue);

      statementdisclosure.readStatementDisclosure(read, {}, (err, res) => {
        if (err) {
          return;
        }
        const response = res.toObject().disclosure;

        let editReq = new StatementDisclosure();
        editReq.setDisclosureId(response.disclosureId);
        editReq.setCorrespondent(response.correspondent);
        editReq.setDisclosure(response.disclosure);
        editReq.setStatus('inactive');

        statementdisclosure.updateStatementDisclosure(
          editReq,
          {},
          (err, res) => {
            if (err) {
              return;
            } else {
              let obj = res.toObject().disclosure;
              const updatedRows = [];
              for (let i = 0; i < rows.length; i++) {
                if (rows[i].disclosureId === obj.disclosureId) {
                  rows[i].correspondent = obj.correspondent;
                  rows[i].disclosure = obj.disclosure;
                  rows[i].status = obj.status;
                } else {
                  updatedRows.push(rows[i]);
                }
              }
              setRows(
                updatedRows.filter(function(value, index, arr) {
                  return value.status === 'active';
                })
              );
            }
          }
        );
      });

      let addReq = new StatementDisclosure();
      addReq.setCorrespondent(modalCorrespondentValue);
      addReq.setDisclosure(modalDisclosureValue);
      addReq.setStatus('active');

      statementdisclosure.createStatementDisclosure(addReq, {}, (err, res) => {
        if (err) {
          notifyError(err.message);
          return;
        } else {
          let obj = res.toObject().disclosure;
          let newStatementDisclosure = {
            correspondent: obj.correspondent,
            disclosure: obj.disclosure,
            status: obj.status,
            disclosureId: obj.disclosureId,
          };
          rows.push(newStatementDisclosure);
          notifySuccess('New Monthly Statement Disclosure has been added.');
          handleClose();
        }
      });
    } else {
      let editReq = new StatementDisclosure();
      editReq.setDisclosureId(modalDisclosureIdValue);
      editReq.setCorrespondent(modalCorrespondentValue);
      editReq.setDisclosure(modalDisclosureValue);
      editReq.setStatus(modalStatusValue);

      statementdisclosure.updateStatementDisclosure(editReq, {}, (err, res) => {
        if (err) {
          console.log(err);
          notifyError(err.message);
          return;
        } else {
          let obj = res.toObject().disclosure;
          for (let i = 0; i < rows.length; i++) {
            if (rows[i].disclosureId === obj.disclosureId) {
              rows[i].correspondent = obj.correspondent;
              rows[i].disclosure = obj.disclosure;
              rows[i].status = obj.status;
            }
          }

          notifySuccess('Monthly Statement Disclosure has been updated.');
          handleClose();
        }
      });
    }
  };

  const updateTableSettings = () => {
    let req = new TableSettings();
    req.setGoogleId(googleAccount.googleId);
    req.setPageName('Monthly Statement Disclosure');
    req.setViewColumns(tableSetting.viewColumns.toString());

    tableSettings.updateTableSettings(req, {}, (err, res) => {
      if (err) {
        console.error(err);
        return;
      }
      notifySuccess('Table has been saved.');
    });
  };

  const [tableSetting, setTableSetting] = useState({
    load: true,
    viewColumns: [],
  });

  const columns = [
    {
      name: '',
      options: {
        draggable: false,
        resizable: false,
        print: false,
        searchable: false,
        filter: false,
        sort: false,
        empty: true,
        viewColumns: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <div
              align={'left'}
              className={classes.grdRow}
              style={{ margin: 0, padding: 0, width: 0 }}
            >
              <div align={'left'} className={classes.grdCellNone}>
                <Tooltip title="Edit" arrow>
                  <div>
                    <IconButton
                      aria-label="edit"
                      onClick={() => handleOpen(rows[dataIndex])}
                    >
                      <EditIcon />
                    </IconButton>
                  </div>
                </Tooltip>
              </div>
            </div>
          );
        },
        setCellProps: () => ({
          style: { padding: '2px 16px' },
        }),
      },
    },
    {
      name: 'correspondent',
      label: 'Correspondent',
    },
    {
      name: 'disclosure',
      label: 'Disclosure',
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        customBodyRenderLite: (dataIndex) => {
          const f = rows[dataIndex].status;
          return (
            <div align="center">
              {f === 'active' ? <CheckCircleIcon /> : null}
            </div>
          );
        },
      },
    },
  ];

  const fileName =
    'MonthlyStatementDisclosure_' +
    moment().format('MMMM Do YYYY, h:mm:ss a') +
    '.csv';

  const options = {
    filterType: 'select',
    download: true,
    filter: true,
    search: false,
    print: false,
    sort: true,
    viewColumns: true,
    columnOrder: [0, 1, 2, 3],
    selectableRowsHeader: false,
    selectableRows: 'none',
    customToolbar: function() {
      return (
        <Tooltip title="Save Table" arrow>
          <IconButton onClick={() => updateTableSettings()}>
            <SaveIcon />
          </IconButton>
        </Tooltip>
      );
    },
    onDownload: () => {
      document.getElementById('csvDL').click();
      return false;
    },
    onTableChange: (action, tableState) => {
      //load table settings

      if (tableSetting.viewColumns.length === 0) {
        let req = new TableSettings();
        req.setGoogleId(googleAccount.googleId);
        req.setPageName('Monthly Statement Disclosure');

        tableSettings.readTableSettings(req, {}, (err, res) => {
          if (err) {
            let req = new TableSettings();
            req.setGoogleId(googleAccount.profileObj.googleId);
            req.setUserName(googleAccount.profileObj.name);
            req.setPageName('Monthly Statement Disclosure');
            req.setViewColumns(tableSetting.viewColumns.join(','));

            tableSettings.createTableSettings(req, {}, (err, res) => {
              if (err) {
                console.error(err);
                return;
              }
            });

            return;
          } else {
            //let viewColumnState = [];
            let viewColumnState = res.toObject().tableSetting.viewColumns;
            let viewColumns = viewColumnState.split(',');

            for (let i = 0; i < tableState.columns.length; i++) {
              tableState.columns[i].display = viewColumns[i];
            }

            setTableSetting({
              load: true,
              viewColumns: viewColumns,
            });
          }
        });
      } else {
        if (tableSetting.load) {
          for (let i = 0; i < tableState.columns.length; i++) {
            tableState.columns[i].display = tableSetting.viewColumns[i];
          }
          tableSetting.load = false;
        }
      }

      let viewColumnState = [];

      for (let i = 0; i < tableState.columns.length; i++) {
        viewColumnState.push(tableState.columns[i].display);
      }

      tableSetting.viewColumns = viewColumnState;
    },
  };

  const [rows, setRows] = useState([]);

  const [correspondentValue, setCorrespondentValue] = React.useState('');
  const [statusValue, setStatusValue] = React.useState('active');
  const [currentPath, setCurrentPath] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [showFilter, setShowFilter] = React.useState(true);

  useEffect(() => {
    const query = new URLSearchParams(params.location.search);
    const path = params.truepath;
    const data = {
      correspondent: query.get('correspondent'),
      status: query.get('status'),
    };

    if (data.correspondent) {
      setCorrespondentValue(data.correspondent);
    }
    if (data.status) {
      setStatusValue(data.status);
    }

    setCurrentPath(path);
  }, [params]);

  const [modalCorrespondentValue, setModalCorrespondentValue] = React.useState(
    ''
  );
  const [modalDisclosureValue, setModalDisclosureValue] = React.useState('');
  const [modalStatusValue, setModalStatusValue] = React.useState('');
  const [modalDisclosureIdValue, setModalDisclosureIdValue] = React.useState(
    ''
  );

  const [modalAddAction, setModalAddAction] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [modalTitleValue, setModalTitleValue] = React.useState('Add New');

  const handleOpen = (rowData, isAdd) => {
    if (isAdd) {
      setModalCorrespondentValue('');
      setModalDisclosureValue('');
      setModalStatusValue('');
      setModalDisclosureIdValue('');

      setModalAddAction(true);
      setModalTitleValue('Add New');
      setOpen(true);
    } else {
      setModalCorrespondentValue(rowData.correspondent);
      setModalDisclosureValue(rowData.disclosure);
      setModalStatusValue(rowData.status);
      setModalDisclosureIdValue(rowData.disclosureId);
      setModalAddAction(false);
      setModalTitleValue('Edit');
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={classes.root}>
      <Box component="div" mt={5}>
        {showFilter ? (
          <div>
            <div className={classes.grdRow}>
              <div className={classes.grdCell1} style={{ marginRight: 30 }}>
                <CorrespondentSelect
                  freeSolo={false}
                  name="correspondent"
                  label="Correspondent"
                  value={correspondentValue}
                  onChange={(e) => {
                    setCorrespondentValue(e.currentTarget.value);
                  }}
                />
              </div>
              <div className={classes.grdCell1}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={statusValue === 'active' ? true : false}
                      onChange={(e) => {
                        console.log(e.target.checked);
                        setStatusValue(
                          e.target.checked === true ? 'active' : ''
                        );
                      }}
                    />
                  }
                  label="Status"
                />
              </div>
              <div className={classes.grdCell1}></div>
              <div className={classes.grdCell1}></div>
            </div>
          </div>
        ) : null}
        <div className={classes.actionContainer}>
          <div className={classes.grdCellNone} style={{ marginRight: 10 }}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              startIcon={<AddIcon />}
              onClick={() => {
                handleOpen('', true);
              }}
            >
              Add New
            </Button>
          </div>
          <div className={classes.grdCellNone}>
            <SearchButton
              onClick={() => search()}
              loading={loading}
              showfilter={(status) => setShowFilter(status)}
            />
          </div>
        </div>
      </Box>
      <Box component="div" mt={2}>
        {rows && (
          <CSVLink id="csvDL" data={rows} filename={fileName} target="_blank" />
        )}
        <MuiThemeProvider theme={tableTheme()}>
          <MUIDataTable
            title={'Monthly Statement Disclosure'}
            data={rows}
            columns={columns}
            options={options}
          />
        </MuiThemeProvider>
      </Box>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modalBackdrop}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={open}>
          <div className={classes.fadeModalMd}>
            <Typography
              id="transition-modal-title"
              variant="h4"
              className={classes.textBold}
              gutterBottom
            >
              {modalTitleValue} Monthly Statement Disclosure
            </Typography>
            <Box mt={5}>
              <form noValidate autoComplete="off">
                <div className={classes.grdRow}>
                  <div className={classes.grdCell1}>
                    <CorrespondentSelect
                      freeSolo={false}
                      name="correspondent"
                      label="Correspondent"
                      value={modalCorrespondentValue}
                      onChange={(e) => {
                        setModalCorrespondentValue(e.currentTarget.value);
                      }}
                    />
                  </div>
                </div>
                <div className={classes.grdRow}>
                  <div className={classes.grdCell1}>
                    <TextField
                      label="Disclosure"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      value={modalDisclosureValue}
                      onChange={(e) => setModalDisclosureValue(e.target.value)}
                      multiline
                      rows={2}
                      rowsMax={4}
                    />
                  </div>
                </div>
                <div className={classes.modalFooter}>
                  <div
                    className={classes.grdCellNone}
                    style={{ marginRight: 10 }}
                  >
                    <Button
                      variant="contained"
                      color="secondary"
                      size="large"
                      onClick={handleClose}
                    >
                      Close
                    </Button>
                  </div>
                  <div className={classes.grdCellNone}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      onClick={() => {
                        save();
                      }}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </form>
            </Box>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
